import { API } from '@/state/api';

//Cache containing prefix/symbol for the currency
const cacheCurrencyData = {
  CAD: {
    prefix: 'CADISC=',
    symbol: '$'
  },
  USD: {
    prefix: 'USDISC=',
    symbol: '$'
  },
  EUR: {
    prefix: 'ECBMRO=',
    symbol: '€'
  }
};

//Cache containing the interest data, lookup by 'Currency Prefix/RIC'
const cacheInterestRates = {};

export const getCurrencyData = (country, currency) => {
  const currencyData = cacheCurrencyData[currency] || {};
  return { country, currency, ...currencyData };
};

export const getInterestRate = (country, currency) => {
  const currencyData = getCurrencyData(country, currency);
  const fids = 'q.RIC,q.PRIMACT_1,q.VALUE_DT1';

  const response = cacheInterestRates[currencyData.prefix];
  if (response) {
    return Promise.resolve(response);
  } else {
    return API.Rest.get(`/quote/info?rics=${currencyData.prefix}&fids=${fids}`).then(({ data }) => {
      data = data.data[0];
      if (data) {
        data['q.PRIMACT_1'] = Math.abs(parseFloat(data['q.PRIMACT_1']));
        cacheInterestRates[currencyData.prefix] = { ...data };
      } else {
        cacheInterestRates[currencyData.prefix] = {};
      }

      return cacheInterestRates[currencyData.prefix];
    });
  }
};
